"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roles = exports.QuestionTypesEnum = exports.Privileges = exports.ClientRoleFeatureKey = exports.ClientRoleFeatureAccessKey = exports.ClientIntegrationActions = void 0;
/** Possible actions for Client Integrations */
var ClientIntegrationActions;
(function (ClientIntegrationActions) {
    ClientIntegrationActions["Subscribe"] = "SUBSCRIBE";
})(ClientIntegrationActions = exports.ClientIntegrationActions || (exports.ClientIntegrationActions = {}));
/** List of available feature access keys */
var ClientRoleFeatureAccessKey;
(function (ClientRoleFeatureAccessKey) {
    ClientRoleFeatureAccessKey["Create"] = "Create";
    ClientRoleFeatureAccessKey["Delete"] = "Delete";
    ClientRoleFeatureAccessKey["Hidden"] = "Hidden";
    ClientRoleFeatureAccessKey["Read"] = "Read";
    ClientRoleFeatureAccessKey["Update"] = "Update";
})(ClientRoleFeatureAccessKey = exports.ClientRoleFeatureAccessKey || (exports.ClientRoleFeatureAccessKey = {}));
/** List of available feature keys */
var ClientRoleFeatureKey;
(function (ClientRoleFeatureKey) {
    ClientRoleFeatureKey["AdminClientRoleManagement"] = "AdminClientRoleManagement";
    ClientRoleFeatureKey["AdminSystemRoleManagement"] = "AdminSystemRoleManagement";
    ClientRoleFeatureKey["CaseformGuidelines"] = "CaseformGuidelines";
    ClientRoleFeatureKey["Dashboards"] = "Dashboards";
    ClientRoleFeatureKey["DownloadSessions"] = "DownloadSessions";
    ClientRoleFeatureKey["DownloadsList"] = "DownloadsList";
    ClientRoleFeatureKey["Line988"] = "Line988";
    ClientRoleFeatureKey["LineAll"] = "LineAll";
    ClientRoleFeatureKey["LineHousing"] = "LineHousing";
    ClientRoleFeatureKey["LineJulieValentineCenter"] = "LineJulieValentineCenter";
    ClientRoleFeatureKey["LineSosLoss"] = "LineSosLoss";
    ClientRoleFeatureKey["PrintToPdf"] = "PrintToPDF";
    ClientRoleFeatureKey["Quicklinks"] = "Quicklinks";
    ClientRoleFeatureKey["ReassuranceCaseformGuidelines"] = "ReassuranceCaseformGuidelines";
    ClientRoleFeatureKey["Resources"] = "Resources";
    ClientRoleFeatureKey["TimesheetsFollowUp"] = "TimesheetsFollowUp";
    ClientRoleFeatureKey["TimesheetsSchedule"] = "TimesheetsSchedule";
})(ClientRoleFeatureKey = exports.ClientRoleFeatureKey || (exports.ClientRoleFeatureKey = {}));
var Privileges;
(function (Privileges) {
    Privileges["Api"] = "API";
    Privileges["Developer"] = "DEVELOPER";
    Privileges["OtpUnverified"] = "OTP_UNVERIFIED";
    Privileges["Private"] = "PRIVATE";
    Privileges["Protected"] = "PROTECTED";
    Privileges["Public"] = "PUBLIC";
    Privileges["System"] = "SYSTEM";
})(Privileges = exports.Privileges || (exports.Privileges = {}));
var QuestionTypesEnum;
(function (QuestionTypesEnum) {
    QuestionTypesEnum["Checkbox"] = "CHECKBOX";
    QuestionTypesEnum["Dropdown"] = "DROPDOWN";
    QuestionTypesEnum["Text"] = "TEXT";
    QuestionTypesEnum["YesOrNo"] = "YES_OR_NO";
})(QuestionTypesEnum = exports.QuestionTypesEnum || (exports.QuestionTypesEnum = {}));
var Roles;
(function (Roles) {
    Roles["ClientAdmin"] = "CLIENT_ADMIN";
    Roles["ClientMember"] = "CLIENT_MEMBER";
    Roles["ClientSales"] = "CLIENT_SALES";
    Roles["None"] = "NONE";
    Roles["ResolvexAdmin"] = "RESOLVEX_ADMIN";
    Roles["ResolvexMember"] = "RESOLVEX_MEMBER";
})(Roles = exports.Roles || (exports.Roles = {}));
//# sourceMappingURL=gen-types.js.map